<template>
  <div class="input-group color-picker" ref="colorpicker">
    <input v-if="!small" type="text" class="form-control" v-model="colorValue" @focus="showPicker()" @input="updateFromInput" />
    <span class="input-group-addon color-picker-container">
      <span class="current-color" :style="'background-color: ' + colorValue" @click="togglePicker()"></span>
    </span>
    <chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker"/>
  </div>
</template>

<script>
import { Chrome } from 'vue-color'
export default {
  name: 'colorpicker',
  components: {
    'chrome-picker': Chrome
  },
  props: {
    color: {
      type: String,
      required: true
    },
	small: {
		type: Boolean
	}
  },
  data() {
    return {
      colors: {
				hex: '#000000',
			},
			colorValue: '',
			displayPicker: false,
    }
  },
  mounted() {
		this.setColor(this.color || '#000000');
  },
  watch: {
		colorValue(val) {
			if(val) {
				this.updateColors(val);
				this.$emit('input', val);
				//document.body.style.background = val;
			}
		}
  },
  methods: {
		setColor(color) {
			this.updateColors(color);
			this.colorValue = color;
		},
		updateColors(color) {
			if(color.slice(0, 1) == '#') {
				this.colors = {
					hex: color
				};
			}
			else if(color.slice(0, 4) == 'rgba') {
				var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
					hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
				this.colors = {
					hex: hex,
					a: rgba[3],
				}
			}
		},
		showPicker() {
			document.addEventListener('click', this.documentClick);
			this.displayPicker = true;
		},
		hidePicker() {
			document.removeEventListener('click', this.documentClick);
			this.displayPicker = false;
		},
		togglePicker() {
			this.displayPicker ? this.hidePicker() : this.showPicker();
		},
		updateFromInput() {
			this.updateColors(this.colorValue);
		},
		updateFromPicker(color) {
			this.colors = color;
			if(color.rgba.a == 1) {
				this.colorValue = color.hex;
			}
			else {
				this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
			}
		},
		documentClick(e) {
			var el = this.$refs.colorpicker, target = e.target;
			if(el && e.target && el !== target && !el.contains(target)) {
				this.hidePicker()
			}
		}
	}
}
</script>

<style>
.color-picker-container {
  position: relative;
}

.vc-chrome {
  position: absolute !important;
  z-index: 9;
  width: 100%;
}

.vc-chrome-fields-wrap {
  display: none;
}

.input-group-addon {
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border-radius: 4px;
  width: 40px;
  white-space: nowrap;
  vertical-align: middle;
  margin-left: -10px;
  margin-top: 0;
  display: inline-block;
}

.current-color {
  display: inline-block;
  width: 39px;
  height: 39px;
  background-color: #000;
  cursor: pointer;
  border: 1px solid black;
}

.form-control {
  width: 220px !important;
}

.form-control:focus {
  outline: none;
}

.vc-input__input {
  border-radius: 8px !important;
  padding: 0 !important;
}

</style>


